import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import Divider from '@mui/material/Divider';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import GaugeChart from "./GaugeChart";
import * as util from "../utils/util";
import api from "../utils/api";
import { getPercentValueForGauge } from "../utils/util";

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const initTargetPressure = {
  bloodPressureLow: 0,
  bloodPressureHigh: 0
}

const HistoryNewInputCard = (props: any) => {
  const navigate = useNavigate();
  const [dayValue, setDayValue] = useState(0);
  const [targetPressure, setTargetPressure] = React.useState(initTargetPressure);

  useEffect(() => {
    setPressureData();
  }, []);

  function setPressureData() {
    // 혈압 정보 조회
    params.token = localStorage.getItem('token') || '';
    params.from = util.getDateByCustom('yyyyMMdd', dayValue - 7);
    params.to = util.getDateByCustom('yyyyMMdd', dayValue);
    params.target = util.getDateByCustom('yyyyMMdd', dayValue);

    api.get(`app/api/v1/AP_002_014?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
      if (res.data.result_code === '0') {
        setTargetPressure(res.data.result_data.target);
      }
    }).catch(function (error) {
      console.log(error)
    });
  }

  // 이완기(61~80), 수축기(101~120) 값에 따른 컴포넌트 리턴
  function getComponentForTargetPressure(targetPressure: any) {
    const low = Number(targetPressure.bloodPressureLow);
    const high = Number(targetPressure.bloodPressureHigh);
    if ((low >= 61 && low <= 80) && (high >= 101 && high <= 120)) {
      return <Typography component={'div'} sx={{ width: '100%', textAlign: 'center', color: '#279700', fontSize: 16, fontWeight: 700, }}>정상</Typography>;
    } else if (low === 0 && high === 0) {
      return <Typography component={'div'} sx={{ width: '100%', textAlign: 'center', color: '#777', fontSize: 16, fontWeight: 700, }}>없음</Typography>;
    } else if (low > 80 || high > 120) {
      return <Typography component={'div'} sx={{ width: '100%', textAlign: 'center', color: '#df0000', fontSize: 16, fontWeight: 700, }}>높음</Typography>;
    } else if (low < 61 || high < 101) {
      return <Typography component={'div'} sx={{ width: '100%', textAlign: 'center', color: '#fba400', fontSize: 16, fontWeight: 700, }}>낮음</Typography>;
    }
  }

  // 이완기(61~80), 수축기(101~120) 값에 따른 문구
  function getTitleForTargetPressure(targetPressure: any) {
    const low = Number(targetPressure.bloodPressureLow);
    const high = Number(targetPressure.bloodPressureHigh);
    if ((low >= 61 && low <= 80) && (high >= 101 && high <= 120)) {
      return '오늘 혈압 수치 측정 완료!';
    } else if (low === 0 && high === 0) {
      return '오늘 혈압을 측정하지 않으셨습니다.';
    } else if (low > 80 || high > 120) {
      return '혈압이 높아요.';
    } else if (low < 61 || high < 101) {
      return '혈압이 낮아요.';
    }
  }

  // 혈압 측정 여부
  function getIsTargetPressure(targetPressure: any) {
    const low = Number(targetPressure.bloodPressureLow);
    const high = Number(targetPressure.bloodPressureHigh);
    return (low > 0 && high > 0) ? 100 : 0;
   
  }



  return (
    <Box alignItems="flex-start" sx={Card_Style} >

      <Typography sx={{ textAlign: 'center', fontSize: 14, fontWeight: 700, p: '15px 0 15px 0' }}>오늘 혈압 수치</Typography>
      <Divider />
      <Box sx={{ p: 0.5 }}>
        <Stack justifyContent={'center'} alignItems={'center'}>
          <Box>
            <GaugeChart targetValue={util.getPercentValueForGauge(targetPressure)} />
            {getComponentForTargetPressure(targetPressure)}
          </Box>
       
            <Button onClick={() => { navigate('../history/Pressure') }} sx={{ flexWrap: 'wrap', p: 0, py:1 }}>
              {/* <Stack sx={{ pb: 1 }} direction={'column'} justifyContent={'center'} alignItems={'center'}> */}
                {/* {getIsTargetPressure(targetPressure) > 0 ? (
                  <MilitaryTechIcon sx={{ fontSize: 30, color: '#ffc007', }} />
                ) : (
                  null
                )} */}

                <Stack direction={'row'} alignItems={'baseline'}>
                  <Typography sx={{ color: '#555', fontSize: 22, pr: '5px', fontWeight: 700 }}>{targetPressure.bloodPressureHigh}/{targetPressure.bloodPressureLow}</Typography>
                  <Typography sx={{ color: '#888', fontSize: 14, textTransform: 'none' }}>mmHg</Typography>
                </Stack>
              {/* </Stack> */}
            </Button>
         

          <Box sx={{ pb: 2 }}>
            <Button onClick={() => { navigate('../history/Pressure') }} sx={{ p: 0, border: '1px solid #EF8322', borderRadius: 5 }}>
              <EditNoteRoundedIcon sx={{ ml: 1, color: '#EF8322' }} />
              <Typography sx={{ color: '#EF8322', fontSize: 14, pr: 1, fontWeight: 700, pl: .5 }}>입력하기</Typography>
            </Button>
          </Box>
        </Stack>
        <Divider />
        <Box sx={{ p: 0.5, }}>
          <Typography sx={{ fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 32, color: '#555' }}> {getTitleForTargetPressure(targetPressure)}</Typography>
        </Box>
      </Box>

      <BorderLinearProgress variant="determinate" value={getIsTargetPressure(targetPressure)}
        sx={{ borderRadius: '0 0 20px 20px', bgcolor: '#eaeaea' }}
      />
    </Box>
  );
  {/* <ListItem alignItems="flex-start" sx={Card_Style} >
          <ListItemAvatar>
              <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
          </ListItemAvatar>
          <ListItemText
          primary ={title} 
          secondary={
              <Box>
                  <Box>{props.values.kcal} {props.values.unitType} 
                      <Button onClick={props.values.navi}>
                          <ModeIcon />
                      </Button>
                  </Box>
                  {props.values.emptyText}
                  <LinearProgress variant="determinate" value={progress} />
              </Box>
          }
          >
          </ListItemText>
      </ListItem> 
  );*/}
}

const BorderLinearProgress = styled(LinearProgress)({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#eaeaea',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#ff4d86',
  },
});

const Card_Style = {
  borderRadius: '10px',
  background: '#fff',
  boxShadow: '0 0 6px  rgba(0,0,0,0.2)',

  flex: '0 50%',
  maxWidth: '100%'
};

export default HistoryNewInputCard;